import { AdminApiSlugs, ApiPrefixes, UserRoleRepresentationDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';

export class KeycloakAdminConnector {
  protected slug = AdminApiSlugs.KEYCLOAK;

  constructor(
    protected apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  getClientRoles(apiPrefix: ApiPrefixes): Observable<UserRoleRepresentationDto[]> {
    return this.apiCaller.getRequest<UserRoleRepresentationDto[]>(apiPrefix, `${this.slug}/client-roles`);
  }
}
